import * as Action from '../action';

const initialState = {
  activeForm: 0,
  openDialogStatus: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Action.SET_BOOK_FEEDER_ACTIVE_FORM:
      return { ...state, activeForm: action.activeForm };
    case Action.SET_NEW_BOOKING_DIALOG_STATUS:
      return { ...state, openDialogStatus: action.status };
    default:
      return state;
  }
};
